export default __webpack_public_path__ + "static/media/quiz-wlk-img.268e8f54.svg";